import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ApiService } from '@shared/services';
import { Observable, of, Subject } from 'rxjs';
import { map, shareReplay, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ReportPipelineService extends ApiService<any> {
  filteredHiringManagersAndRecruiters$: Observable<any>;
  filteredOptions$: Observable<string[]>;
  private filteredHiringManagersAndRecruiters = new Subject<any>();

  constructor(http: HttpClient) {
    super(http);
    this.url = 'aggregated/pipeline/';

    this.filteredHiringManagersAndRecruiters$ = this.filteredHiringManagersAndRecruiters.pipe(
      switchMap((filter) =>
        filter.name !== null && filter.name.length > 0
          ? this.reportsHiringManagerAndRecruiterAutocomplete(
              filter.name,
              filter.jobFunction,
              filter.jobDepartment,
              filter.jobStatus,
            )
          : of([]),
      ),
      shareReplay(1),
    );

    this.filteredOptions$ = this.filteredHiringManagersAndRecruiters$.pipe(
      map((hiringManagersAndRecruiters) => hiringManagersAndRecruiters),
      shareReplay(1),
    );
  }

  reportsHiringManagerAndRecruiterAutocomplete(
    phrase: string,
    jobFunction: string,
    jobDepartment: string,
    jobStatus: string,
  ): Observable<string> {
    const params = {
      searchString: phrase,
      jobFunction,
      jobDepartment,
      jobStatus,
    };
    return this.get({ url: 'autocomplete', params });
  }

  triggerAutocomplete(
    name: string,
    jobFunction: string,
    jobDepartment: string,
    jobStatus: string,
  ): void {
    this.filteredHiringManagersAndRecruiters.next({ name, jobFunction, jobDepartment, jobStatus });
  }

  getJobFunctionsForPipeline(params): Observable<string[]> {
    return this.get({ url: 'functions', params });
  }

  getJobDepartmentsForPipeline(params): Observable<string[]> {
    return this.get({ url: 'departments', params });
  }
}
